import React, { useState } from "react";
import { privateAxios } from "../utils/axios";
import { usePermissionContext } from "../contexts/PermissionContext";
import toast from "react-hot-toast";

const defaultPermissions = [
  {
    module: "products",
    permissions: [],
  },
  {
    module: "supplier",
    permissions: [],
  },
  {
    module: "purchase",
    permissions: [],
  },
  {
    module: "expense",
    permissions: [],
  },
  {
    module: "returns",
    permissions: [],
  },
  {
    module: "users",
    permissions: [],
  },
  {
    module: "purchase-report",
    permissions: [],
  },
  {
    module: "expense-report",
    permissions: [],
  },
  {
    module: "products-report",
    permissions: [],
  },
   {
    module: "setting",
    permissions: [],
  },
];

function AddUser({ addUserModalSetting, handlePageUpdate }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    role: "admin",
    permissions: defaultPermissions,
    isActive: true,
  });
  const [loading, setLoading] = useState(false);
  const { onUserUpdated } = usePermissionContext();

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "isActive") {
      setForm((prev) => ({ ...prev, isActive: checked }));
    } else if (name === "role") {
      setForm((prev) => ({
        ...prev,
        role: value,
        permissions:
          value === "admin"
            ? defaultPermissions.map((module) => ({
                ...module,
                permissions: ["read", "write", "delete"],
              }))
            : defaultPermissions,
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Handle permission changes
  const handlePermissionChange = (moduleIndex, permission, checked) => {
    setForm((prev) => {
      const updatedPermissions = [...prev.permissions];
      if (checked) {
        updatedPermissions[moduleIndex].permissions.push(permission);
      } else {
        updatedPermissions[moduleIndex].permissions = updatedPermissions[
          moduleIndex
        ].permissions.filter((perm) => perm !== permission);
      }
      return { ...prev, permissions: updatedPermissions };
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        ...form,
        permissions: form.permissions,
      };
      const res = await privateAxios.post("/users", payload);
      if (res.data.success) {
        toast.success("User added successfully");
        handlePageUpdate();
        addUserModalSetting();
      } else {
        toast.error(res.data.message || "Failed to add user");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error adding user");
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-lg">
        <h2 className="text-xl font-bold mb-4">Add User</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-medium mb-1">Name</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Phone</label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
            />
          </div>
          {/* <div>
            <label className="block font-medium mb-1">Email</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              type="email"
            />
          </div> */}
          <div>
            <label className="block font-medium mb-1">Password</label>
            <input
              name="password"
              value={form.password}
              onChange={handleChange}
              required
              className="w-full border rounded px-3 py-2"
              type="password"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Role</label>
            <select
              name="role"
              value={form.role}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
            >
              <option value="admin">Admin</option>
              <option value="user">User</option>
            </select>
          </div>
          <div>
            <label className="block font-medium mb-1">Permissions</label>
            <div className="space-y-3 max-h-60 overflow-y-auto">
              {form.permissions.map((module, moduleIndex) => (
                <div key={module.module} className="border rounded p-3">
                  <h4 className="font-medium mb-2 capitalize">
                    {module.module.replace("-", " ")}
                  </h4>
                  <div className="flex gap-4">
                    {["read", "write", "delete"].map((permission) => (
                      <label
                        key={permission}
                        className="flex items-center gap-1"
                      >
                        <input
                          type="checkbox"
                          checked={module.permissions.includes(permission)}
                          onChange={(e) =>
                            handlePermissionChange(
                              moduleIndex,
                              permission,
                              e.target.checked
                            )
                          }
                          disabled={form.role === "admin"}
                        />
                        <span className="text-sm">{permission}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="isActive"
                checked={form.isActive}
                onChange={handleChange}
              />
              Active
            </label>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              className="px-4 py-2 rounded bg-gray-200"
              onClick={addUserModalSetting}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded bg-blue-600 text-white"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddUser;
